import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { loadCatalog } from "../lib/catalog";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=none, obj=auth
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password, businessCode = "") => {
    const { data } = await api.post("/auth/login", { email, password, business_code: businessCode });
    if (data.access_token) localStorage.setItem("nx_token", data.access_token);
    await refresh();
    if (data.user?.business_id) loadCatalog({ force: true }).catch(() => {}); // catálogo del POS en memoria desde el inicio de sesión
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("nx_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
